const finalizeForm = (state = {}, action) => {
    switch (action.type) {
        case 'SET_ORGANIZATION_NAME':
            return {
                ...state,
                bandName: action.payload
            };
        case 'SET_FIRST_NAME':
            return {
                ...state,
                firstName: action.payload
            };
        case 'SET_LAST_NAME':
            return {
                ...state,
                lasttName: action.payload
            };
        case 'SET_USER_NAME':
            return {
                ...state,
                userName: action.payload
            };
        case 'SET_USER_INITIALS':
            return {
                ...state,
                userInitials: action.payload
            };
        case 'SET_IMPRESSIONS_STATUS':
            return {
                ...state,
                impStatus: action.payload
            };
        case 'SET_RUSH_ORDER_STATUS':
            return {
                ...state,
                rushStatus: action.payload
            };
        case 'SET_ORDER_NOTES':
            return {
                ...state,
                orderNotes: action.payload
            };
        case 'SET_TEXT_ON_TOP':
            return {
                ...state,
                textOnTop: action.payload
            };
        case 'SET_TEXT_ON_BOTTOM':
            return {
                ...state,
                textOnBottom: action.payload
            };
        case 'IS_TEXT_ON_CASE':
            return {
                ...state,
                isTextOnCase: action.payload
            };
        case 'SET_CARE_PLAN_SELECTED':
            return {
                ...state,
                carePlanSelected: action.payload
            };
        case 'SET_FORM_DATA':
            return {
                ...state,
                bandName: action.payload.bandName,
                firstName: action.payload.firstName,
                lastName: action.payload.lastName,
                userName: action.payload.userName,
                userInitials: action.payload.userInitials,
                impStatus: action.payload.impStatus,
                rushStatus: action.payload.rushStatus,
                orderNotes: action.payload.orderNotes,
                textOnTop: action.payload.textOnTop,
                textOnBottom: action.payload.textOnBottom,
                isTextOnCase: action.payload.isTextOnCase
            };
        default:
            return state;
    }
};
export default finalizeForm;
